let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g49kY")).then(() => parcelRequire('dgI5j'));